<template>
  <BaseModal overlay-class="modal_games_left">
    <div class="content">
      <BaseImage :src="gamesImage" alt="Games Left" />

      <h3 class="title">
        {{ $_translations.value.modal_balance_game_title_pt1 }}
        <span>{{ authStore.user.availableGames }}</span>
        {{ $_translations.value.modal_balance_game_title_pt2 }}
      </h3>

      <p>{{ $_translations.value.modal_balance_game_description }}</p>

      <div class="progress_unlocked">
        <div class="flex-column">
          <BaseProgressBar :value="authStore.userNextLevelProgressPercentage" />

          <div class="flex-row stats ga_W">
            <p class="games_won">
              <span>{{ authStore.user.gamesPlayed || 0 }}</span>
              {{ $_translations.value.modal_balance_game_games_completed }}
            </p>

            <p v-if="!authStore.hasUserCompletedAllLevels" class="points_to_lvl">
              <span>{{ authStore.userNextLevelGapTotal }}</span>
              {{ $_translations.value.modal_balance_game_games_to_level_up }}
            </p>
          </div>
        </div>
      </div>

      <p>
        {{ $_translations.value.modal_balance_game_extra_info_pt1 }}<br>
        {{ $_translations.value.modal_balance_game_extra_info_pt2 }}<br>
        <b>{{ $_translations.value.modal_balance_game_extra_info_pt3 }}</b>
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseProgressBar from '@/components/bar/BaseProgressBar.vue';
import useAuthStore from '@/store/modules/auth.js';
import { gamesImage } from '@/constants/image.js';

const authStore = useAuthStore();
</script>
